<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <tabela
          :loading="loading"
          :items="items"
          :ultimoRegistro="ultimoRegistro"
          :versao="versao"
          @rechargeTable="getModulos('Atual')"
          @changeVersao="versao = $event, getModulos($event)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
import ModulosAneelService from '@/services/ModulosAneelService';
import pusherMixins from "@/mixins/pusherMixins";
import tourMixins from '@/mixins/tourMixins';
  
export default {
  mixins: [pusherMixins, tourMixins],
  
  components: {
    Tabela: () => import('@/components/modulosAneel/Tabela.vue')
  },
  
  mounted() {
    this.getModulos();
    this.subscribe();
  },
  
  data: () => ({
    items: [],
    loading:false,
    ultimoRegistro:'',
    versao:'Atual',
    arrTour: [
      {
        element: '#btn-calcular-modulos',
        intro: 'Clicando neste botão você poderá calcular os modulos aneel de acordo com os índices IPCA.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: "#atualizacao-modulos-search",
        intro: "Neste campo você poderá pesquisar por data do modulo.",
        scrollTo: "tooltip",
        position: 'bottom'
      },
      {
        element: '#btn-visualizar-modulos-anteriores',
        intro: 'Clicando neste botão você podera visualizar os antigos modulos.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: "#action-baixar-csv-modulos",
        intro: "Clicando neste ícone você poderá efetuar o download em formato csv do módulo desejado.",
        scrollTo: "tooltip",
        position: 'left'
      },
      {
        element: '#action-excluir-modulo',
        intro: 'Clicando neste ícone você poderá excluir o ultimo modulos registrado.',
        scrollTo: "tooltip",
        position: 'left'
      }, 
      {
        element: '#link-visualizar-modulo',
        intro: 'Clicando neste link você poderá visualizar o modulo desejado.',
        scrollTo: "tooltip",
        position: 'right'
      }
    ]
  }),
  
  methods: {
    subscribe() {
      this.pusherChannel.bind('reload-pag-atualizacao-modulos', () => {
        this.getModulos(this.versao);
      });
    },

    getModulos(versao = 'Atual') {
      this.loading = true;
      ModulosAneelService.getModulos(versao).then((response) => {
        this.items = response.data.data;
        this.ultimoRegistro = this.items[0].DataRegistro;
      })
      .catch(() => this.$toast.error('Erro ao buscar Modulos.', '', { position: 'topRight' }))
      .finally(() => {
        this.iniciarTourPagina();
        this.loading = false;
      });
    },
    
    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0,2);
      this.iniciarTour(arrTourFormatted);
    }
  }
}
</script>